<template>
    <div class="panel panel-default panel-dashboard">
        <LoadingSpinner v-if="data === null"/>

        <div v-else class="panel-body text-center">
            <div class="row">
                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 28px; margin-bottom: 0">
                        {{ value | price }}
                    </p>

                    <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
                        Commission
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 28px; margin-bottom: 0">
                        {{ advertisingValue | price }}
                    </p>

                    <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
                        Advertising Commission
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 28px; margin-bottom: 0">
                        {{ subscriptionValue | price }}
                    </p>

                    <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
                        Subscription Commission
                    </p>
                </div>

                <div class="col-xs-6">
                    <p style="font-size: 28px; margin-bottom: 0">
                        {{ adjustmentValue | price }}
                    </p>

                    <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
                        Adjustments
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    props: {
        user: {
            required: true,
            type: Object
        },

        year: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            data: null
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        year() {
            this.load()
        }
    },

    computed: {
        value() {
            return this.data.reduce((total, row) => total + row.commission_value, 0)
        },

        advertisingValue() {
            return this.data
                .filter(row => row.commissionable_type === 'time-based-ads' || row.commissionable_type === 'publication-based-ads')
                .reduce((total, row) => total + row.commission_value, 0)
        },

        subscriptionValue() {
            return this.data
                .filter(row => row.commissionable_type === 'subscription-periods')
                .reduce((total, row) => total + row.commission_value, 0)
        },

        adjustmentValue() {
            return this.data
                .filter(row => row.commissionable_type === 'commission-items')
                .reduce((total, row) => total + row.commission_value, 0)
        }
    },

    methods: {
        load() {
            http.post('/api/v1/reports/new-analytics', {
                metrics: [
                    {name: 'commission_value'}
                ],
                dimensions: [
                    {name: 'commissionable_type'}
                ],
                filters: [
                    {dimension: 'sold_month', operator: 'like', value: '%/' + this.year},
                    {dimension: 'user_id', operator: '=', value: this.user.id}
                ]
            })
                .then(response => {
                    this.data = response.data.data
                })
        }
    }
}
</script>
